import { motion } from "framer-motion";
import { Instagram as IgIcon } from "lucide-react";
import { IG_IMAGES, INSTAGRAM } from "../../data";
import { Reveal } from "./Reveal";

export const InstagramSection = () => (
    <section
        id="instagram"
        data-testid="instagram-section"
        className="py-20 md:py-28 px-4 bg-gradient-to-b from-transparent via-lightpink/15 to-transparent"
    >
        <div className="max-w-6xl mx-auto">
            <Reveal className="text-center mb-4">
                <h2 className="font-display font-bold text-4xl md:text-6xl text-gradient-pink">
                    Síguenos en Instagram 📸
                </h2>
                <a
                    href={INSTAGRAM}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="ig-handle"
                    className="mt-3 inline-block font-display font-semibold text-lg text-hotpink hover:text-strawred transition-colors"
                >
                    @quefresas.es
                </a>
            </Reveal>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {IG_IMAGES.map((src, i) => (
                    <Reveal key={i} delay={i * 0.06}>
                        <motion.a
                            href={INSTAGRAM}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.03 }}
                            data-testid={`ig-card-${i}`}
                            className="group relative block aspect-square rounded-2xl overflow-hidden shadow-lg shadow-hotpink/10"
                        >
                            <img
                                src={src}
                                alt="Publicación de Instagram de ¡Qué Fresas!"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-hotpink/0 group-hover:bg-hotpink/30 transition-colors grid place-items-center">
                                <IgIcon className="text-white opacity-0 group-hover:opacity-100 transition-opacity" size={30} />
                            </div>
                        </motion.a>
                    </Reveal>
                ))}
            </div>

            <div className="mt-10 flex justify-center">
                <motion.a
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.96 }}
                    href={INSTAGRAM}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="ig-button"
                    className="inline-flex items-center gap-2 bg-hotpink text-white font-display font-semibold text-lg px-8 py-4 rounded-full shadow-xl shadow-hotpink/40"
                >
                    <IgIcon size={22} /> Ver Instagram 🍓
                </motion.a>
            </div>
        </div>
    </section>
);
